<template>
  <div class="container">
    <div class="con_wrap">
      <div class="con_title">
        <img class="con_title_icon" src="../../assets/images/evaluate/success.png" >
        <div class="con_title_t">
          提交成功！
        </div>
      </div>
      <div class="con_tips">已成功提交，请耐心等待反馈</div>
      <div class="con_btn_wrap">
        <div class="con_btn2" @click="back">返回</div>
        <div class="con_btn" @click="details">{{title?title:"查看我的报修"}}</div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name:"success",
  data () {
    return {
      title:""
    }
  },
  created () {
    this.title =  this.$route.query.title
  },
  methods: {
    back(){
      window.history.back(-1);
    },
    details(){
      let id = this.$route.query.id
      if(this.title=='查看投诉建议'){
        this.$router.push(`/repairComplaintDetails?id=${id}`);
      }else{
        this.$router.push(`/repairOrderDetails?id=${id}`);
      }

    },
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.con_wrap{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.con_title{
  margin-bottom: 28px;
  margin-top: 200px;
  height:66px;
  display: flex;
  align-items: center;
  .con_title_icon{
    width: 44px;
    height: 44px;
    margin:12px 14px 10px;
  }
  .con_title_t{
    font-size:48px;
    font-family:PingFangSC;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:66px;

  }
}
.con_tips{
  height:40px;
  font-size:28px;
  font-family:PingFangSC;
  font-weight:400;
  color:rgba(153,153,153,1);
  line-height:40px;
  margin-bottom: 120px;
  text-align: center;
}
.con_btn_wrap{
  width: 100%;
  display: flex;
  padding: 0 34px;
  box-sizing: border-box;
}
.con_btn,.con_btn2{
  flex: 1;
  height:76px;
  margin: 0 10px;
  background:rgba(23,64,218,1);
  border:1px solid rgba(23,64,218,1);
  border-radius:4px;
  text-align: center;
  line-height: 76px;
  font-size:32px;
  font-weight:400;
  color:rgba(255,255,255,1);
  box-sizing: border-box;
}
.con_btn2{
  background:rgba(243,245,253,1);
  border:1px solid rgba(150,170,240,1);
  color: #1740DA
}
</style>
